import { render, staticRenderFns } from "./CodeDisplay.vue?vue&type=template&id=7770d93a&scoped=true&lang=html&"
import script from "./CodeDisplay.vue?vue&type=script&lang=js&"
export * from "./CodeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770d93a",
  null
  
)

export default component.exports